import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { ParentContentCardMultiHeader } from '../common/ParentContentCardMultiHeader';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/ext-language_tools';
import { UploadRestApiPreview } from './item/import/UploadRestApiPreview';
import { filterObjectsForRestApi } from '../../common/utils/rest_utils';
import _ from 'lodash';
import { toast } from 'react-toastify';
import CustomLoader from '../common/CustomLoader';
import CollectionHeaderNav from './CollectionHeaderNav';
import { excludedFields } from '../common/FieldTypes';

export class ImportFromRestApi extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    url: '',
    methodType: 'get',
    restApiHeaders: [],
    header: [{ key: '', value: '' }],
    responseData: '',
    finalData: [],
    selectedCollection: '',
    itemsPath: '',
    bodyJSON: '',
    urlError: '',
  };
  handleChange = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  };
  handleChangekeyValue = (index, field, value) => {
    const header = [...this.state.header];
    header[index][field] = value;
    if (index === header.length - 1 && (header[index].key || header[index].value)) {
      header.push({ key: '', value: '' });
    }
    this.setState({ header });
  };

  async componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    const result = await actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    const { collections } = this.props;
    const { fields } = collections.selectedCollection;
    this.setState({ selectedCollection: collections.selectedCollection });
    await this.extractHeaders(fields);
  }
  extractHeaders = (data) => {
    const result = data
      .filter((field) => !excludedFields.includes(field.fieldTitle.en))
      .map((field) => field.fieldTitle.en);
    this.setState({ restApiHeaders: result });
    return;
  };
  handleCancel = () => {
    const { collections, match, history } = this.props;
    const { selectedCollection } = collections;
    const { collectionName } = selectedCollection;
    const { projectId, collectionId, version } = match.params;
    history.push(
      `/collections/${version}/v/${projectId}/items/${collectionId}/name/${collectionName}`,
    );
  };
  handleSendRequest = async () => {
    const { methodType, url, header, bodyJSON, itemsPath, restApiHeaders } = this.state;
    if (!url) {
      this.setState({ urlError: 'This field is required' });
      return;
    }
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    header.forEach((pair) => {
      if (pair.key && pair.value) {
        headers[pair.key] = pair.value;
      }
    });
    let body = null;
    if (methodType !== 'get') {
      body = bodyJSON ? JSON.parse(bodyJSON) : null;
    }
    const { actions } = this.props;
    await actions.responceForRestApi({ methodType, url, headers, body, fullData: true });
    const { collections } = this.props;
    let { responseData } = collections;
    responseData = Array.isArray(responseData) ? responseData : [responseData];
    const finalResponse = itemsPath ? _.get(responseData, itemsPath) : responseData;
    const finalData = await filterObjectsForRestApi(finalResponse, restApiHeaders);
    if (finalData.length === 0) {
      toast.error('No Matching Items Found');
    }
    this.setState({ finalData });
  };

  handleImport = async () => {
    const { match, actions, collections, history } = this.props;
    const { projectId, version, collectionId } = match.params;
    const { finalData, selectedCollection } = this.state;
    const { collectionName } = selectedCollection;
    await actions.importItemsFromRestApi({
      projectId,
      version,
      collectionName,
      finalData,
    });
    history.push(
      `/collections/${version}/v/${projectId}/items/${collectionId}/name/${collectionName}`,
    );
  };

  render() {
    const { match, collections } = this.props;
    const { responceForRestApiPending, importItemsFromRestApiPending, selectedCollection } =
      collections;
    const { projectId, version } = match.params;
    const { urlError, dataItem, restApiHeaders, finalData, bodyJSON, header, methodType } =
      this.state;
    return (
      <CommonPageComponent>
        <CollectionHeaderNav
          label="REST_API"
          projectId={projectId}
          version={version}
          selectedCollection={selectedCollection}
          uploadHeaders
        />
        <ParentContentCardMultiHeader
          isSearch={false}
          btnSize="sm"
          title="Import Items From REST API"
          icon="collection"
          bgColor="drapcode-violet"
          projectId={projectId}
          version={version}
          isEnvironmentInline
        >
          <>
            {finalData && finalData.length > 0 ? (
              <UploadRestApiPreview headers={restApiHeaders} restApiData={finalData} />
            ) : (
              <>
                <div className="row">
                  <div className="col-sm-2">
                    <CustomInputWithIcon icon="select" title="Select Request Type">
                      <select
                        name="methodType"
                        onChange={this.handleChange}
                        value={this.state.methodType}
                        className="form-control form-control-sm custom-select-sm"
                      >
                        <option value="get">GET</option>
                        <option value="post">POST</option>
                      </select>
                    </CustomInputWithIcon>
                  </div>
                  <div className="col-sm-10">
                    <CustomInputWithIcon icon="url" title="URL">
                      <input
                        id="url"
                        name="url"
                        type="text"
                        className="form-control form-control-sm"
                        onChange={this.handleChange}
                        value={this.state.url}
                        placeholder="REST API URL"
                      />
                      {urlError && <p className="text-danger">{urlError}</p>}
                    </CustomInputWithIcon>
                  </div>
                </div>
                <div className="card">
                  <h4>
                    <b className="ml-4">Headers</b>
                  </h4>
                  <div className="row pt-2">
                    <div className="col-md-4 col-lg-4">
                      <label className="ml-4">Key</label>
                    </div>
                    <div className="col-md-8 col-lg-8">
                      <label className="ml-4">Value</label>
                    </div>
                  </div>
                  <div className="pb-4">
                    {header.map((pair, index) => (
                      <div className="row pt-2" key={index}>
                        <div className="col-md-4 col-lg-4 ml-4 ">
                          <input
                            name="key"
                            type="text"
                            placeholder="key"
                            className="form-control form-control-sm"
                            onChange={(e) =>
                              this.handleChangekeyValue(index, 'key', e.target.value)
                            }
                            value={pair.key}
                          />
                        </div>
                        <div className="col-md-7 col-lg-7 ">
                          <div>
                            <input
                              name="value"
                              type="text"
                              placeholder="Value"
                              className="form-control form-control-sm"
                              onChange={(e) =>
                                this.handleChangekeyValue(index, 'value', e.target.value)
                              }
                              value={pair.value}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className=" col-sm-12">
                  <CustomInputWithIcon icon="text">
                    <input
                      name="itemsPath"
                      onChange={this.handleChange}
                      value={dataItem}
                      className="form-control form-control-sm"
                      placeholder="Response Data Items Path (Optional)"
                    />
                  </CustomInputWithIcon>
                </div>
                {methodType === `post` && (
                  <div className="mx-auto">
                    <div className="form-group">
                      <div className="card">
                        <div className="m-3">
                          <h4>
                            <b> Request Body JSON</b>
                          </h4>
                        </div>
                        <AceEditor
                          height="250px"
                          width="100%"
                          mode="json"
                          theme="github"
                          value={bodyJSON}
                          onChange={(e) => this.setState({ bodyJSON: e })}
                          showPrintMargin={false}
                          setOptions={{
                            enableBasicAutocompletion: true,
                            enableLiveAutocompletion: true,
                            enableAutoIndent: true,
                            enableSnippets: true,
                          }}
                          editorProps={{ $blockScrolling: true }}
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className="text-right ml-3">
                  <button
                    className="btn btn-theme-submit mt-3"
                    onClick={this.handleSendRequest}
                    disabled={responceForRestApiPending}
                  >
                    <i className="wb webconnect-rocket"></i>
                    &nbsp;Send Request&nbsp;
                    <CustomLoader loading={responceForRestApiPending}></CustomLoader>
                  </button>
                </div>
              </>
            )}
            <div className="text-start flex-start">
              <button
                type="button"
                className="btn btn-outline btn-md  "
                onClick={this.handleCancel}
                title="Cancel REST API Import"
              >
                <i className="wb webconnect-times"> </i> Cancel
              </button>
              &nbsp;
              {finalData && finalData.length > 0 && (
                <button
                  type="button"
                  className="btn btn-theme-submit btn-md"
                  onClick={this.handleImport}
                  title="Import REST API Content"
                >
                  <i className="wb webconnect-upload"></i>
                  &nbsp;Import
                  <CustomLoader loading={importItemsFromRestApiPending} />
                </button>
              )}
            </div>
          </>
        </ParentContentCardMultiHeader>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportFromRestApi);
